import { getTranslation } from 'helpers/getTranslation';

export const columns = [
  {
    key: 'title',
    label: 'Title',
    minWidth: 280,
    sortable: true,
  },
  {
    key: 'courses',
    label: 'Courses',
    minWidth: 240,
  },
  {
    key: 'schools',
    label: getTranslation('courses_lessons_page.table_keys.schools'),
    minWidth: 160,
  },
  {
    key: 'status',
    label: 'Status',
    minWidth: 120,
  },
  {
    key: 'createdAt',
    label: 'Created at',
    sortable: true,
  },
  {
    key: 'updatedAt',
    label: 'Updated at',
    sortable: true,
  },
];
